export default "__VITE_ASSET__9ba80f78__"